<template lang="slm">
.container v-if="size === 'Lite'"
  .column.is-8.is-7-widescreen.is-offset-2.is-paddingless-mobile
    figure.Figure(itemprop="image" itemscope itemtype="http://schema.org/ImageObject" ref="imageContainer")
      image-source :source="imageUrl" :ratio=1.78 :alt="caption" :widths="smallWidths" v-if="width" :width="width"
      meta itemprop="representativeOfPage" content="true"
      meta itemprop="width" content="1360"
      meta itemprop="height" content="#{1360/1.78}"
      meta itemprop="url contentUrl" content="metaContentUrl"
      figcaption.Figure-caption
        .content
          p itemprop="caption" {{caption}}

.container v-else-if="size === 'Medium'"
  .column.is-10.is-offset-1.is-paddingless-mobile
    figure.Figure(itemprop="image" itemscope itemtype="http://schema.org/ImageObject" ref="imageContainer")
      image-source :source="imageUrl" :ratio=1.78 :alt="caption" :widths="mediumWidths" v-if="width" :width="width"
      meta itemprop="representativeOfPage" content="true"
      meta itemprop="width" content="1360"
      meta itemprop="height" content="#{1360/1.78}"
      meta itemprop="url contentUrl" content="metaContentUrl"
      figcaption.Figure-caption
        .content
          p itemprop="caption" {{caption}}

.container v-else-if="size === 'Stort'"
  .column.is-12.is-paddingless-mobile
    figure.Figure(itemprop="image" itemscope itemtype="http://schema.org/ImageObject" ref="imageContainer")
      image-source :source="imageUrl" :ratio=1.78 :alt="caption" :widths="bigWidths" v-if="width" :width="width"
      meta itemprop="representativeOfPage" content="true"
      meta itemprop="width" content="1360"
      meta itemprop="height" content="#{1360/1.78}"
      meta itemprop="url contentUrl" content="metaContentUrl"
      figcaption.Figure-caption
        .content
          p itemprop="caption" {{caption}}

figure.Figure(itemprop="image" itemscope itemtype="http://schema.org/ImageObject" v-else-if="size === 'Fullbredde' || !size" ref="imageContainer")
  image-source :source="imageUrl" :ratio=1.78 :alt="caption" :widths="mediumWidths" v-if="width" :width="width"
  meta itemprop="representativeOfPage" content="true"
  meta itemprop="width" content="1360"
  meta itemprop="height" content="#{1360/1.78}"
  meta itemprop="url contentUrl" content="metaContentUrl"
  figcaption.Figure-caption
    .content
      p itemprop="caption" {{caption}}
</template>

<script>
import ImageSource from '@/components/ImageSource'

export default {
  components: {
    'image-source': ImageSource
  },
  props: ['size', 'caption', 'imageUrl'],
  data () {
    return {
      smallWidths: [700, 700, 700],
      mediumWidths: [700, 1500, 2000],
      bigWidths: [700, 2000, 2400],
      metaContentUrl: `${this.imageUrl}?w=2000&h=#{1360/1.78}`,
      width: null
    }
  },
  mounted () {
    this.width = this.$refs.imageContainer.clientWidth
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/ImageBlock.vue